import getApiClient from "./../../../../../shared/api";
import {
    showInfo,
    showError,
    clearNotifications,
    showWarning
} from "../../../../../notifications/ducks/actions";

const url = "/film";

export const FETCH_MAKEUP_OVERVIEW = "FETCH_MAKEUP_OVERVIEW";
export const SAVE_ALIAS_MAKEUP = "SAVE_ALIAS_MAKEUP";
export const SAVE_UNALIAS_MAKEUP = "SAVE_UNALIAS_MAKEUP";
export const DELETE_MULTIPLE_MAKEUPS = "DELETE_MULTIPLE_MAKEUPS";

export function fetchMakeupOverview(id) {
    return (dispatch) => {
        dispatch({
            type: FETCH_MAKEUP_OVERVIEW,
            payload: getApiClient().get(`${url}/${id}/Makeup/Overview`)
        });
    };
}

export function aliasMakeup(filmId, aliasMakeup, preferredMakeup) {
    return (dispatch) => {
        dispatch({
            type: SAVE_ALIAS_MAKEUP,
            payload: getApiClient().put(
                `${url}/${filmId}/Makeup/${preferredMakeup.id}/Alias`,
                { aliasId: aliasMakeup.id }),
            meta: { aliasMakeup, preferredMakeup }
        })
            .then((response) => {
                dispatch(
                    showInfo(`Aliased ${aliasMakeup.name} with ${preferredMakeup.name}`)
                );
            })
            .catch((response) => {
                dispatch(
                    showError(
                        `Error aliasing ${aliasMakeup.name} with ${preferredMakeup.name}`
                    )
                );
            })
            .then((response) => {
                dispatch(clearNotifications());
            });
    };
}

export function unaliasMakeup(filmId, aliasMakeup, preferredMakeup) {
    return (dispatch) => {
        dispatch({
            type: SAVE_UNALIAS_MAKEUP,
            payload: getApiClient().put(
                `${url}/${filmId}/Makeup/${preferredMakeup.id}/RemoveAlias`,
                { aliasId: aliasMakeup.id }
            ),
            meta: { aliasMakeup, preferredMakeup }
        })
            .then((response) => {
                dispatch(
                    showInfo(
                        `Removed alias ${aliasMakeup.name} from ${preferredMakeup.name}`
                    )
                );
            })
            .catch((response) => {
                dispatch(
                    showError(
                        `Error removing alias ${aliasMakeup.name} from ${preferredMakeup.name}`
                    )
                );
            })
            .then((response) => {
                dispatch(clearNotifications());
            });
    };
}

export function deleteMultipleMakeups(filmId, makeupIds) {
    return (dispatch) => {
        dispatch({
            type: DELETE_MULTIPLE_MAKEUPS,
            payload: getApiClient().post(`${url}/${filmId}/Makeup/deleteMultiple`, { makeupIds }),
            meta: { makeupIds }
        })
            .then((response) => {
                dispatch(showInfo(`Deleted ${makeupIds.length} makeup${makeupIds.length !== 1 ? 's' : ''}`));
            })
            .catch((response) => {
                dispatch(showError(`Error deleting makeups`));
            })
            .then((response) => {
                dispatch(clearNotifications());
            });
    };
}
